module.exports = __webpack_public_path__ + "img/7A736F_463F33_575046_4B463D-256px.c371a377.png";